import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertToString from "../../../../../components/Converter";
import AlertBox from "../../../../../components/Messages";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import { ResultSpan } from "../../../../../components/styledComponents/Result";
import ToolTip, { IconType } from "../../../../../components/ToolTip";
import { selectBohrkronendurchmesser } from "../../../../../store/slices/bohrkronendurchmesserSlice";
import {
  selectAnzahlLastwechsel,
  selectSchwingungsObergrenze,
  selectSchwingungsUntergrenze,
} from "../../../../../store/slices/innereSlice";

// Ausnutzung
// Utilisation Factor
function Ausnutzung({ ausnutzung }) {
  const { t } = useTranslation("translation");
  const bohrkronendurchmesser = useSelector(selectBohrkronendurchmesser);

  const schwingungsObergrenze = useSelector(selectSchwingungsObergrenze);
  const schwingungsUntergrenze = useSelector(selectSchwingungsUntergrenze);
  const anzahlLastwechsel = useSelector(selectAnzahlLastwechsel);

  const eta_Formula = `\\displaystyle η = \\frac{F_{d,Δσ}}{R_{d,Δσ}} \\le 1,0`;
  let error = t("inner.biggerDesignLoad");

  function showError() {
    if (
      schwingungsObergrenze === undefined ||
      schwingungsUntergrenze === undefined ||
      anzahlLastwechsel === undefined
    )
      return false;

    if (!isValid() && bohrkronendurchmesser != 0) {
      return true;
    }

    return false;
  }

  function isValid() {
    return Number(ausnutzung) > 0 && Number(ausnutzung) <= 1 ? true : false;
  }

  return (
    <>
      <RowBody
        titleValue={<p>{t("inner.verificationCapacity.utilizationFactor.headline")}</p>}
        formulaValue={<ToolTip id={"eta_Formula"} type={IconType.FORMULA} formula={eta_Formula} />}
        indicesValue={<span>&eta;</span>}
        inputValue={<ResultSpan valid={isValid()}>{ConvertToString(ausnutzung, 2)}</ResultSpan>}
      />
      <Col md={8}>
        <AlertBox show={showError()} message={error} />
      </Col>
    </>
  );
}

export default Ausnutzung;
